// @ts-nocheck

export type OwnerListIsEchoesOwner = typeof OwnerListIsEchoesOwner[keyof typeof OwnerListIsEchoesOwner];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OwnerListIsEchoesOwner = {
  true: 'true',
  false: 'false',
} as const;
